import { css } from '@emotion/react'
import styled from '@emotion/styled'

import theme from 'styles/theme'

export const SharedInputStyles = css({
  borderRadius: theme.token('borderRadius.small'),
  fontSize: theme.token('fontSizes.sm'),
  backgroundColor: theme.token('colors.light'),
  width: '100%',

  // This is to prevent zoom in on iOS. According to this SO thread https://stackoverflow.com/questions/2989263/disable-auto-zoom-in-input-text-tag-safari-on-iphone/6394497
  // if font size in input is smaller than 16px, iOS will zoom in and therefore break layout. Using this bit of code we can detect iPhone and set there font size equal to 16px.
  '@media screen and (-webkit-min-device-pixel-ratio: 0)': {
    fontSize: '16px',
  },

  '&:focus': {
    outline: 'none',
    boxShadow: 'none',
    border: 'none',
  },

  '&:disabled': {
    opacity: 0.5,
    pointerEvents: 'none',
  },
})

export const StyledInput = styled.input<{
  isError: boolean
  paddingLeft: string
  paddingRight: string
  isSmaller: boolean
  disabled?: boolean
}>(({ isError, paddingLeft, paddingRight, isSmaller }) => {
  const base = SharedInputStyles
  const extra = {
    color: isError ? theme.token('colors.red.a150') : theme.token('colors.black'),
    border: isError ? `1px solid ${theme.token('colors.red.a100')}` : 'none',
    paddingLeft: paddingLeft,
    paddingRight: paddingRight,
    height: isSmaller ? '36px' : '54px',
    display: 'block',

    '&::placeholder': {
      color: isError ? theme.token('colors.red.a150') : theme.token('colors.green.a200'),
    },
  }

  return [base, extra]
})

export const StyledTextarea = styled.textarea<{ isError: boolean }>(({ isError }) => [
  SharedInputStyles,
  {
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    transition: '0.2s',
    outline: 'none',
    appearance: 'none',
    padding: '8px 1rem',
    height: '2.5rem',
    minHeight: '80px',
    lineHeight: 1.375,
    borderRadius: '9px',
    fontSize: '1.4rem',
    backgroundColor: 'rgb(243, 247, 247)',
    width: '100%',

    color: isError ? theme.token('colors.red.a150') : theme.token('colors.black'),
    border: isError ? `1px solid ${theme.token('colors.red.a100')}` : 'none',

    '&::placeholder': {
      color: isError ? theme.token('colors.red.a150') : theme.token('colors.green.a200'),
    },
  },
])
